import type { GDSIconToken } from '../../theme/icons/get-theme-icons';

/**
 * Additional icon names corresponding to existing ones,
 * but which signal to the `Icon` component that they should be
 * flipped horizontally depending on the text directionality of the app
 * (e.g., right-to-left).
 */
export const directionalityAwareAliases = {
  interfaceArrowBack: 'interfaceArrowLeft',
  interfaceArrowForward: 'interfaceArrowRight',
  interfaceChevronBack: 'interfaceChevronLeft',
  interfaceChevronForward: 'interfaceChevronRight',
  tinyDisclosureIndicator: 'tinyDisclosureIndicator',
  tinyExternalLink: 'tinyExternalLink',
  tinyNewWindowInternal: 'tinyNewWindowInternal',
  tinyBackButton: 'tinyBackButton',
} as const satisfies Record<string, GDSIconToken>;
